<template>
  <div class="up-load">
    <!-- 上传  -->
    <!-- <el-button class="table_header_btn" @click="upLoadBut" size="medium"
      >上传</el-button
    > -->
    <el-dialog
      title="新增素材"
      :visible.sync="dialogTableVisible"
      width="800px"
      class="main_dialog"
    >
      <!-- 警告 -->
      <el-alert type="warning" :closable="false" show-icon>
        <p style="font-size: 14px">
          最多可同时上传两百张，单张素材图片最大不能超过10M
        </p>
      </el-alert>
      <!-- 上传图片 -->
      <el-upload
        action
        accept=".jpg, .png"
        drag
        class="upload-box"
        list-type="picture"
        ref="upload"
        multiple
        :limit="200"
        :http-request="handleUploadImg"
      >
        <i class="el-icon-upload"></i>
        <!-- 、webp -->
        <p>点击或拖拽文件到这里上传，支持文件类型：jpg、png</p>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <el-image width="100%" :src="upFileList" alt="#" />
      </el-dialog>
      <!-- 同意协议 -->
      <!-- <el-checkbox
        v-model="protocol"
        style="
          white-space: pre-wrap;
          display: flex;
          align-items: flex-start;
          margin-top: 24px;
        "
        >上传图片和文字时不得存在涉政、涉黄、侵权等违法行为，情节严重的将予以封号处理，感谢您的配合。我已经阅读并同意。</el-checkbox
      > -->
      <div style="text-align: right;">
        <!-- <el-button type="primary" @click="dialogTableVisible = false">编辑图片</el-button> -->
        <el-button class="dialog_cancel" size="small" @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { folderFileUpload } from "@/api/material";
export default {
  name: "LibraryUpload",
  props: {
    activeID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // 窗口是否下显示
      dialogTableVisible: false,
      dialogVisible: false,
      upFileList: [],
      //  协议
      protocol: false,
    };
  },
  methods: {
    handleUploadImg(param) {
      const isLt20M = Number(param.file.size / 1024 / 1024) < 20;
      if (!isLt20M) {
        this.$message.warning('图片过大，已自动压缩')
      }
      let formData = new FormData()
      formData.append('file', param.file)
      formData.append('folder_id', this.activeID)
      folderFileUpload(formData).then(res => {
        // this.generateForm.image = res.data.url
        this.upFileList.push(res.data)
      })
    },
    handleChange(file, fileList, scope) {
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024);
      console.log("文件大小：", imgSize);
      if (imgSize > 10) {
        this.$msgbox({
          title: "",
          message: "文件大小不能超过10MB，请重新上传。",
          type: "warning",
        });
        fileList.splice(scope.index, 1);
        return;
      }
    },
    upLoadBut() {
      this.dialogTableVisible = true;
      this.upFileList = [];
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      console.log(this.fileList);
      if (res.code == 1) {
        this.$message({
          type: "success",
          message: res.msg,
        });
      } else {
        file.status = "fail";
        this.fileList = fileList;
        this.$message({
          type: "error",
          message: res.msg,
          duration: "5000",
        });
      }
      this.$nextTick(() => {
        const a = document
          .getElementsByClassName("is-fail")
          [
            document.getElementsByClassName("is-fail").length - 1
          ].getElementsByClassName("el-upload-list__item-name")[0];
        let p = document.createElement("p");
        p.style.color = "red";
        p.innerHTML = `${res.msg || "上传失败：未知错误，请联系管理员"}`;
        a.appendChild(p);
      });
    },
    // 上传失败
    uploadError(res) {
      console.log(res);
    },
    beforeUploadFj(file) {
      const validFormats = ["image/webp"];
      if (!validFormats.includes(file.type)) return true; // 如果不是 WebP 格式，直接上传
      console.log("image/webp", file);
      // 使用 FileReader 读取文件
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = async (e) => {
          try {
            // 创建 Image 对象
            const img = new Image();
            img.onload = async () => {
              // 创建 canvas
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;

              // 绘制图像
              ctx.drawImage(img, 0, 0);

              // 转换为 PNG 数据 URL
              const pngDataUrl = canvas.toDataURL("image/png");

              // 创建新的文件对象
              const response = await fetch(pngDataUrl);
              const blob = await response.blob();
              const newFile = new File(
                [blob],
                file.name.replace(/\.webp$/, ".png"),
                {
                  type: "image/png",
                }
              );

              // 替换上传的文件
              file = newFile;
              let imgSize = Number(file.size / 1024 / 1024);
              console.log("装换后文件以及文件大小:", file, imgSize);
              if (imgSize > 10) {
                this.$msgbox({
                  title: "",
                  message: "webp转换png后文件大小超过10MB，请重新上传。",
                  type: "warning",
                });
                reject(false);
              } else {
                resolve(file);
              }
            };
            img.src = e.target.result;
            console.log("img.src", e.target.result);
          } catch (error) {
            this.$message.error(error);
            reject(error);
          }
        };
        reader.readAsDataURL(file);
      });
    },
  },
  watch: {
    dialogTableVisible(v) {
      if (!v) {
        this.$emit("update");
        this.$refs.upload.clearFiles();
      }
    },
  },
  computed: {
    soureUpLoad() {
      return soureUpLoad();
    },
  },
};
</script>

<style scoped lang="scss">
.up-load {
  display: inline-block;
  .table_header_btn {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 4px;
    background: var(--work-color);
    color: #ffffff;
    &.is-disabled {
      filter: opacity(0.6);
    }
  }
}
.upload-box {
  margin: 24px 0;
  ::v-deep .el-upload-list--picture {
    max-height: 300px;
    overflow-y: auto;
    .el-upload-list__item-thumbnail{
      background-repeat: repeat;
      background-position: center;
      object-fit: contain;
    }
  }
  ::v-deep .el-upload {
    display: flex;
    justify-content: center;
    .el-upload-dragger {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 10px;
      // width: 600px;
      width: 100%;
      .el-icon-upload {
        margin-top: 10px;
      }
      &:hover {
        // color: $--color-primary;
        .el-icon-upload {
          // color: $--color-primary;
        }
      }
    }
  }
}
.downloadPlugin {
  // color: $--color-primary;
  cursor: pointer;
}
</style>
